<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.complaint_type_id" placeholder="投诉类型" filterable class="filter-item" style="width: 140px" clearable>
        <el-option v-for="item in complaintTypes" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="投诉人" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.user.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
            <span>{{ scope.row.user.name }}</span>
            <span>{{ scope.row.user.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="投诉类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.complaint_type.name }}
        </template>
      </el-table-column>

      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="投诉留言" min-width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>

      <el-table-column label="图片" min-width="350" align="center">
        <template slot-scope="scope">
          <viewer :images="scope.row.pictures">
            <img v-for="(src,index) in scope.row.pictures" :src="src" :key="index" style="margin-right: 10px; width: 100px; height: 100px; object-fit: contain; border: 1px solid #ccc; border-radius: 5px; cursor: pointer;">
          </viewer>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <div style="margin: 10px 0;">
            <template v-if="scope.row.complaintReplyAdminUnreadCount > 0">
              <el-badge :value="scope.row.complaintReplyAdminUnreadCount">
                <el-button type="primary" size="mini" @click="handleReplyContent(scope.row)">回复</el-button>
              </el-badge>
            </template>
            <template v-else>
              <el-button type="primary" size="mini" @click="handleReplyContent(scope.row)">回复</el-button>
            </template>
          </div>

        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 回复内容 -->
    <el-dialog :visible.sync="dialogVisibleReplyContent" width="50%" :close-on-click-modal="false">
      <div style="height: 500px" class="scrollbar">
        <el-scrollbar style="height: 500px">
          <el-table :data="complaintReplyList" style="width: 1100px">
            <el-table-column label="角色" min-width="110" align="center">
              <template slot-scope="scope">
                {{ scope.row.user_id > 0 ? "用户" : "商家" }}
              </template>
            </el-table-column>

            <el-table-column label="内容" min-width="200" align="center">
              <template slot-scope="scope">
                {{ scope.row.reply_content }}
              </template>
            </el-table-column>

            <el-table-column label="时间" min-width="110" align="center">
              <template slot-scope="scope">
                {{ scope.row.created_at }}
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-form ref="replyContentForm" :rules="replyContentRules" :model="replyContentForm" label-width="150px">
        <el-form-item label="回复内容" prop="reply_content">
          <el-input v-model="replyContentForm.reply_content" type="textarea" :rows="4" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReplyContent = false">取消</el-button>
        <el-button type="primary" @click="saveDataReplyContent" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 回复内容 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          complaint_type_id: "",
        },
        complaintTypes: [],
        btnLoading: false,
        dialogVisibleReplyContent: false,
        replyContentForm: {
          id: "",
          reply_content: "",
        },
        replyContentRules: {
          reply_content: [{ required: true, message: "回复内容不能为空", trigger: "change" }],
        },
        complaintReplyList: null,
      };
    },
    created() {
      this.getList();
      this.getComplaintTypeList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
        this.getComplaintTypeList();
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/complaint/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      getComplaintTypeList() {
        request({
          url: "/api/backend/complaintType/list",
          method: "get",
          params: {
            page: 1,
            limit: 100000,
            school_id: this.school_id
          }
        }).then(response => {
          this.complaintTypes = response.data.data;
        });
      },
      getComplaintReplyList(complaintId) {
        this.complaintReplyList = [];
        request({
          url: "/api/backend/complaint/complaintReplyList",
          method: "get",
          params: {
            id: complaintId
          }
        }).then(response => {
          this.complaintReplyList = response.data;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      // 回复内容
      handleReplyContent(item) {
        item.complaintReplyAdminUnreadCount = 0;
        this.getComplaintReplyList(item.id);
        this.replyContentForm = {
          id: item.id,
          reply_content: "",
        }
        this.dialogVisibleReplyContent = true;
        this.$nextTick(() => {
          this.$refs["replyContentForm"].clearValidate() //清除校验结果
        })
      },
      saveDataReplyContent() {
        this.$refs["replyContentForm"].validate((valid) => {
          if (valid) {
            this.btnLoading = true;
            request({
              url: "/api/backend/complaint/replyContent",
              method: "post",
              data: this.replyContentForm
            }).then(() => {
              this.dialogVisibleReplyContent = false;
              this.$message({
                type: "success",
                message: "操作成功!"
              });
              this.getList();
            }).finally(() => {
              this.btnLoading = false;
            });
          }
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
